import { Stroke, Style } from "ol/style";
import { extractTags } from "./propertyExtraction";

export function getOsmLanesNormStyleNormal(feature) {
  return getOsmLanesNormColorStyle(feature);
}

export function getOsmLanesNormStyleClick(feature) {
  return getOsmLanesNormColorStyle(feature, true, false);
}

export function getOsmLanesNormStyleHover(feature) {
  return getOsmLanesNormColorStyle(feature, false, true);
}

function getOsmLanesNormColorStyle(feature, click = false, hover = false) {
  const tags = extractTags(feature);
  if (
    tags.lanesNormMotorVehicle === undefined &&
    tags.lanesNormMotorCar === undefined &&
    tags.lanesNormHgv === undefined &&
    tags.lanesNormPsv === undefined &&
    tags.lanesNormBus === undefined &&
    tags.lanesNormTaxi === undefined &&
    tags.lanesNormHov === undefined
  ) {
    return [
      new Style({
        stroke: new Stroke({
          color: "transparent",
          width: 0,
        }),
      }),
    ];
  }

  let color;
  let backgroundColor = "white";
  let width;
  let backgroundWidth;
  if (tags.lanesNormBus === "yes") {
    color = "maroon";
    width = 4;
    backgroundWidth = 6;
  } else if (tags.lanesNormHgv === "yes") {
    color = "purple";
    width = 4;
    backgroundWidth = 6;
  } else if (tags.lanesNormPsv === "yes") {
    color = "blue";
    width = 4;
    backgroundWidth = 6;
  } else if (tags.lanesNormTaxi === "yes") {
    color = "yellow";
    width = 4;
    backgroundWidth = 6;
  } else if (tags.lanesNormHov === "yes") {
    color = "orange";
    width = 4;
    backgroundWidth = 6;
  } else if (tags.lanesNormMotorCar === "yes") {
    color = "green";
    width = 4;
    backgroundWidth = 6;
  } else if (
    tags.lanesNormMotorVehicle !== undefined &&
    tags.lanesNormMotorVehicle !== "yes"
  ) {
    color = "darkgrey";
    width = 4;
    backgroundWidth = 6;
  } else {
    color = "grey";
    width = 1;
    backgroundWidth = 2;
  }

  if (hover || click) {
    backgroundWidth = 6;
    return [
      new Style({
        stroke: new Stroke({
          color: backgroundColor,
          width: backgroundWidth,
        }),
      }),
      new Style({
        stroke: new Stroke({
          color: color,
          width: width,
        }),
      }),
    ];
  }
  return [
    new Style({
      stroke: new Stroke({
        color: backgroundColor,
        width: backgroundWidth,
      }),
    }),
    new Style({
      stroke: new Stroke({
        color: color,
        width: width,
      }),
    }),
  ];
}
